export default __webpack_public_path__ + "static/media/gusto3.0f50eef8.jpg";